import { styled } from 'parkdepot-shared/theme'
import primitives from 'parkdepot-shared/theme/primitives'

export const Container = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column'
}))

export const Info = styled('div', ({ $theme }) => ({
    height: '2rem',
    marginTop: '2rem'
}))

export const ChartContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    marginTop: '2rem',
    borderTop: `1px dashed ${primitives.mono300}`
}))

export const Chart = styled('div', ({ $theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    height: '74px',
    alignItems: 'flex-end',
    gap: '3px'
}))

type BarProps = {
    value: number
    colored: boolean
}

const BAR_MAX_HEIGHT = 58 // in px

export const Bar = styled<'div', BarProps>('div', ({ value, colored }) => ({
    flexGrow: 1,
    borderRadius: '2px',
    minHeight: '3px',
    maxHeight: `${BAR_MAX_HEIGHT}px`,
    height: `${(value * BAR_MAX_HEIGHT) / 100}px`,
    backgroundColor: colored ? primitives.primary : primitives.mono200
}))

export const Time = styled('div', ({ $theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    fontWeight: 700,
    fontSize: '8px',
    lineHeight: '16px'
}))
